import { Card, CardContent, Grid, Typography } from '@material-ui/core';
import React from 'react';
import { useStyles } from './Styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const DisplayCard = (props) => {
  const classes = useStyles();
  const {
    primaryText,
    secondaryText,
    loading,
    selected,
    handleClick,
    tertiaryText,
    primaryTextColor,
    secondaryTextColor,
  } = props;

  return (
    <Grid item className={classes.G1}>
      <Card
        className={selected ? classes.cardSelected : classes.cardStyle}
        onClick={handleClick}
      >
        <CardContent className={classes.cardContent}>
          {loading ? (
            <Grid container className={classes.G2}>
              <CircularProgress color='primary' thickness={7} />
            </Grid>
          ) : (
            <Grid container style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '4px' }}>
                <Typography 
                  style={{
                    textAlign: 'center',
                    fontWeight: 500,
                    fontSize: '2.5rem',
                    lineHeight: 1.2,
                    color: primaryTextColor || 'inherit',
                  }}
                >
                  {primaryText}
                </Typography>
              </Grid>
              <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography 
                  style={{
                    textAlign: 'center',
                    fontSize: '1rem',
                    fontWeight: 700,
                    lineHeight: 1.2,
                    wordWrap: 'break-word',
                    overflowWrap: 'break-word',
                    padding: '2px',
                    color: secondaryTextColor || 'inherit',
                  }}
                >
                  {secondaryText}
                  {tertiaryText && (
                    <React.Fragment>
                      <br /> {tertiaryText}
                    </React.Fragment>
                  )}
                </Typography>
              </Grid>
            </Grid>
          )}
        </CardContent>
      </Card>
    </Grid>
  );
};

export default DisplayCard;

